import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Mail, X } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Iter122bf · Banner "email dedicata" mostrato all'admin studio.
 * - Compare quando: banner_dismissed=false AND email_notifiche_indirizzo non impostata
 * - Persiste la scelta backend (per-tenant): POST /api/settings/email-banner-dismiss
 * - Non compare per condòmini/fornitori (l'endpoint richiede role='admin').
 */
export default function EmailPolicyBanner({ user }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || user.role !== "admin") return;
    api.get("/settings/email-banner-state")
       .then((r) => setShow(!!r.data.show_banner))
       .catch(() => {});
  }, [user?.id]);  // eslint-disable-line react-hooks/exhaustive-deps

  const dismiss = async () => {
    setShow(false);
    try { await api.post("/settings/email-banner-dismiss"); } catch {}
  };

  if (!show) return null;

  return (
    <div className="mx-4 mt-4 p-4 rounded-lg border-2 border-amber-300 bg-amber-50/70 flex items-start gap-3" data-testid="email-policy-banner">
      <Mail className="w-6 h-6 text-amber-700 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="font-bold text-amber-900 mb-1">Vuoi ridurre le email nella casella dello Studio?</div>
        <p className="text-sm text-amber-800 leading-relaxed">
          Ginius invia diverse notifiche via email (manutenzioni, preventivi, sinistri…). Per evitare di sovraccaricare
          l'account di posta principale, ti suggeriamo di creare presso il tuo provider un <b>indirizzo dedicato</b>
          (es. <code className="px-1 rounded bg-amber-100">notifiche.ginius@iltuostudio.it</code>) e di indicarlo nel Pannello,
          oppure di disattivare le categorie di notifica non necessarie.
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
          <Link to="/pannello?section=email-prefs" data-testid="email-policy-open-pannello"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-amber-700 text-white text-sm font-bold hover:bg-amber-800">
            Configura ora →
          </Link>
          <button data-testid="email-policy-dismiss" onClick={dismiss}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border-2 border-amber-300 text-amber-800 text-sm font-semibold hover:bg-amber-100">
            Ho capito, ricordamelo più tardi
          </button>
        </div>
      </div>
      <button data-testid="email-policy-close" onClick={dismiss} className="text-amber-700 hover:text-amber-900 shrink-0" aria-label="Chiudi banner">
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
